import { useRequest } from '@Hooks/useRequest';
import { API } from '@Services';
import { SelectionStatusEnum } from '@Types/Selection';
import { useCallback } from 'react';

export interface FundSelectionsDataResponse {
  total_funding: number;
  total_count: number;
}

export const useGetFundSelectionsData = () => {
  const [fetch, response] = useRequest<FundSelectionsDataResponse>();

  const getFundSelectionsData = useCallback(
    (fundId: number, statuses: SelectionStatusEnum[]) => {
      fetch(API.paths.fund_selections_data(fundId), 'get', {
        params: {
          statusIn: statuses.join(','),
        },
      });
    },
    [fetch],
  );

  return [getFundSelectionsData, response] as const;
};
